import { loadOrFallback } from "@compass/shared/utils/pdfPreviewErrors";
import { Suspense, lazy } from "react";
import type { InlinePDFPreviewProps } from "./InlinePDFPreview";
import { PdfPreviewUnavailable } from "./PdfPreviewUnavailable";
import { reportPdfPreviewError } from "./reportPdfPreviewError";

/**
 * The PDF viewer (react-pdf 11 / PDF.js 6, ~460 KB) lives in its own chunk,
 * loaded on first use. If the chunk fails to load (offline, a deploy replaced
 * it) the viewer degrades to a download link instead of breaking the screen;
 * a load failure is a breadcrumb, any other import error is reported.
 */
const LazyViewer = lazy(() =>
    loadOrFallback(
        () => import("./InlinePDFPreview").then((m) => ({ default: m.InlinePDFPreview })),
        { default: PdfPreviewUnavailableAdapter },
        // Always fall back; a chunk that loaded but threw is still reported.
        reportPdfPreviewError,
    ),
);

const PdfPreviewUnavailableAdapter: React.FC<InlinePDFPreviewProps> = ({ onDownload }) => (
    <PdfPreviewUnavailable onDownload={onDownload} />
);

export const LazyInlinePDFPreview: React.FC<InlinePDFPreviewProps> = (props) => (
    <Suspense fallback={<span className="p-2 text-xs text-slate-500">Loading PDF...</span>}>
        <LazyViewer {...props} />
    </Suspense>
);
